<template>
    <div>
        <div class="nav">
            <img class="logo" src="../assets/images/Logo.png" alt="">
            <div style="display:flex;align-items: center;">
                <div class="nav-btn" v-if="!isPhone">
                    <span @click="handleToPage('protac')">{{ $t('from.index') }}</span>
                    <span @click="handleToPage('services', 1)" :class="{ 'selected': isSelect == 1 }">{{ $t('from.service')
                    }}</span>
                    <span @click="handleToPage('productView', 5)" :class="{ 'selected': isSelect == 5 }">{{
                        $t('from.product')
                    }}</span>
                    <span @click="handleToPage('about', 2)" :class="{ 'selected': isSelect == 2 }">{{ $t('from.about')
                    }}</span>
                    <span @click="handleToPage('testimonial', 3)" :class="{ 'selected': isSelect == 3 }">{{ $t('from.putai')
                    }}</span>
                    <span @click="handleToPage('contact', 4)" :class="{ 'selected': isSelect == 4 }">{{ $t('from.contact')
                    }}</span>
                </div>
                <el-dropdown class="nav-right" @command="handleCommand">
                    <el-button type="primary" class="nav-btn" round>{{ $t('from.changeLanguage') }}</el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="英文"> {{ $t('language.English') }}</el-dropdown-item>
                        <el-dropdown-item command="中文">{{ $t('language.Chinese') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <i class="el-icon-s-operation iconfont" @click="handleShowMenu" v-if="!isShow && isPhone"></i>
            <i class="el-icon-close iconfont" @click="handleCloseMenu" v-if="isShow && isPhone"></i>
        </div>
        <div class="show-builder-menu" v-if="isShow">
            <span @click="handleToPage('protac')">{{ $t('from.index') }}</span>
            <span @click="handleToPage('services', 1)" :class="{ 'selected': isSelect == 1 }">{{ $t('from.service')
            }}</span>
            <span @click="handleToPage('productView', 5)" :class="{ 'selected': isSelect == 5 }">{{
                $t('from.product')
            }}</span>
            <span @click="handleToPage('about', 2)" :class="{ 'selected': isSelect == 2 }">{{ $t('from.about') }}</span>
            <span @click="handleToPage('testimonial', 3)" :class="{ 'selected': isSelect == 3 }">{{ $t('from.putai')
            }}</span>
            <span @click="handleToPage('contact', 4)" :class="{ 'selected': isSelect == 4 }">{{ $t('from.contact')
            }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isSelect: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isShow: false,
            isPhone: false,
        }
    },
    mounted() {
        var info = navigator.userAgent;
        //通过正则表达式的test方法判断是否包含“Mobile”字符串
        this.isPhone = /mobile/i.test(info);
        //如果包含“Mobile”（是手机设备）则返回true
        console.log('isPhone', this.isPhone)
    },
    methods: {
        handleCommand(text) {
            console.log('text', text);
            if (text == '英文') {
                window.sessionStorage.setItem('language', 'en')
                this.$emit('handleCommand', 'en')
            } else if (text == '中文') {
                this.$emit('handleCommand', 'zh')
                window.sessionStorage.setItem('language', 'zh')
            }
        },
        handleToPage(url, index) {
            console.log(url)
            this.$router.push({ name: url, query: { index: index } })
            this.isShow = false
        },
        handleShowMenu() {
            this.isShow = true
        },
        handleCloseMenu() {
            this.isShow = false
        }
    }
}
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 750px) {
    .show-builder-menu {
        position: fixed;
        top: 60px;
        left: 0;
        width: 100%;
        z-index: 99;
        background-color: #f7fdfb;
        display: flex;
        flex-direction: column;

        span {
            line-height: 40px;
            padding: 0 20px;
            border-bottom: 1px solid #d5dbd9;
        }
    }

    .nav {
        height: 60px;
        width: 100%;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        z-index: 999;
        box-shadow: 0px 10px 25px -3px rgba(43, 61, 80, 0.1);
        padding: 15px;
        box-sizing: border-box;

        .logo {
            width: 64;
            height: 47px;
        }

        .nav-btn {
            display: none;
        }
    }
}

@media only screen and (min-width: 751px) {
    .nav {
        height: 120px;
        width: 100%;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        z-index: 999;
        box-shadow: 0px 10px 25px -3px rgba(43, 61, 80, 0.1);
        padding: 30px;
        box-sizing: border-box;

        .logo {
            width: 160px;

        }

        .nav-btn {
            span {
                font-size: 18px;
                font-weight: bold;
                padding: 0 20px;
                cursor: pointer;
            }

            span:hover {
                color: #1b5fc1;
            }

            .selected {
                color: #1b5fc1;
                font-weight: bold;
            }
        }
    }
}
</style>